import React from "react";
import BookingAdditionalInformationCustomerFields from "./BookingAdditionalInformationCustomerFields";

export default class BookingAdditionalInformation extends React.Component {

	constructor(props) {
		super(props);
    this.state = {
      errors: null,
      success: null,
    	loading: false,
    };
	}

  /**
  * Render functions
  */

	render() {
    {this.renderErrors()}
    {this.renderSuccess()}
    return (
      <div>
        <BookingAdditionalInformationCustomerFields {...this.props} />
      </div>
    );
  }

  renderErrors() {
		var self = this;
		if (this.hasErrors()) {
			if (Array.isArray(this.state.errors)) {
				var errors = this.state.errors.map(function (error) {
          return <li key={error} dangerouslySetInnerHTML={{__html: self.processError(error)}}></li>
	      });
			} else {
				var errors = Object.keys(this.state.errors).map(function (key) {
          if (I18n.lookup(key)) {
            var name = I18n.t(key)
          } else {
            var name = self.props.form_fields.filter((field) => { return key == field.id })[0].field
          }
	      	return <li key={key}>{name} {self.state.errors[key][0]}</li>
	      });
			}
      return (       
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
		}
	}

  renderSuccess() {
    if (this.state.success) {
      return (
        <div className="alert alert-success">
          <ul>{this.state.success}</ul>
        </div>
      );
    }
  }

  /** Helper function **/

  hasErrors() {
    return this.state.errors && ((Array.isArray(this.state.errors) && this.state.errors.length > 0) || Object.keys(this.state.errors).length > 0)
  }

}